import { useBreakpoints, breakpointsTailwind } from "@vueuse/core"
import { computed } from "vue"

const breakpoints = useBreakpoints(breakpointsTailwind)

export const useResponsive = () => {
    const isMobile = breakpoints.smallerOrEqual("md")
    const isTablet = computed(
        () =>
            breakpoints.smallerOrEqual("lg").value &&
            breakpoints.greater("md").value
    )
    const isDesktop = breakpoints.greater("lg")

    const isMobileOrTablet = breakpoints.smaller("lg")

    /**
     * Même bascule que la grille du formulaire (`--small-viewport`, 640 px) :
     * sert à empiler les boutons quand le libellé ne tient pas (DEV-2274).
     */
    const isSmallViewport = breakpoints.smallerOrEqual("sm")

    return {
        isMobile,
        isSmallViewport,
        isTablet,
        isDesktop,
        isMobileOrTablet,
    }
}
